import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.local';
import { RecentlyUploadedVideosHttpResult } from '../models/video.model';
import { IVideoApi } from './interfaces/video-abstract.api';
import { ApiHttpResponse, VideoSection } from '@kinomap-dev/ng-ui-lib';

@Injectable({
  providedIn: 'root',
})
export class VideoApi implements IVideoApi {
  constructor(private readonly http: HttpClient) {}

  getVideos(
    page: number,
    limit: number,
    userId: number = null,
    params: HttpParams = new HttpParams()
  ): Observable<ApiHttpResponse<VideoSection[]>> {
    if (!params.has('page')) params = params.append('page', page);
    if (!params.has('limit')) params = params.append('limit', limit);
    if (!params.has('withoutCoaching'))
      params = params.append('withoutCoaching', true);

    const url: string = environment.api.dashboard.myVideos;
    return this.http.get<ApiHttpResponse<VideoSection[]>>(url, {
      params: params,
    });
  }

  deleteVideo(videoId: number): Observable<any> {
    const url: string = environment.api.dashboard.deleteVideo.replace(
      '{video-section}',
      '' + videoId
    );
    return this.http.delete<any>(url);
  }

  getVideosPolylinesOnly(userId: number): Observable<any> {
    const url: string = environment.api.dashboard.videosPolylines.replace(
      '{user}',
      '' + userId
    );
    return this.http.get<any>(url);
  }

  getVideoInformations(videoId: number): Observable<any> {
    const url: string = environment.api.dashboard.videoInformations.replace(
      '{videoId}',
      '' + videoId
    );
    return this.http.get<any>(url);
  }

  getRecentlyploadedVideos(): Observable<RecentlyUploadedVideosHttpResult> {
    const url: string = environment.api.dashboard.myRecentlyUploadedVideos;
    return this.http.get<RecentlyUploadedVideosHttpResult>(url);
  }

  reportWatchVideo(videoId: number, reason: string): Observable<any> {
    const url: string = environment.api.watch.reportVideo.replace(
      '{videoId}',
      '' + videoId
    );
    const requestBody = {
      reason: reason,
    };
    return this.http.post(url, requestBody);
  }

  reportCoachingVideo(videoId: number, reason: string): Observable<any> {
    const url: string = environment.api.coaching.report.replace(
      '{videoId}',
      '' + videoId
    );
    const requestBody: { reason: string } = {
      reason: reason,
    };
    return this.http.post(url, requestBody);
  }
}
